<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <v-card v-if="$store.getters.getLanguageList">     
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer('user')}}</div>
            <div v-if="needInit">{{initData()}}</div> 
            <div v-if="myContent">
                <div v-for="(item,index) in myList" :key="index">
                    <p v-if="item.type=='<p>'">
                        <span v-for="(el,index2) in item.list" :key="index2">
                            <span v-if="el.type == 'c'" v-html="el.content"></span>
                            <span v-if="el.type == 'a'" >
                                <v-chip>
                                    <input v-if="showAns == 0" type = "text" v-bind:style="getStyle(index, index2)" v-model = "el.content" :size = "el.content.length+1">
                                    <!-- <span v-if="showAns == 1" type = "text" v-bind:style="getStyle(index, index2)"> {{el.answer}}</span> -->
                                    <span v-if="showAns == 2" type = "text" v-bind:style="getStyle(index, index2)">{{el.content}}</span>
                                    <v-icon v-if="showAns == 2 && (myCompare(el.content,el.answer))"  v-bind:style="check_ok" >check_circle</v-icon>  
                                    <v-icon v-if="showAns == 2 && (!myCompare(el.content,el.answer))"  v-bind:style="check_error">error</v-icon>  
                                </v-chip>
                                <v-chip v-if="showAns == 2 && (el.content != el.answer)" color="lime lighten-3">
                                    <span type = "text" v-bind:style="correct_answer">{{el.answer}}</span>
                                </v-chip>
                            </span>
                        </span>
                    </p>       
                    <div id = "mycode" v-if="item.type=='<pre'">
                        <span v-for="(el,index2) in item.list" :key="index2">
                            <span v-if="el.type == 'c'" v-html="el.content"></span>
                            <span v-if="el.type == 'a'" >
                                <v-chip>
                                    <input v-if="showAns == 0" type = "text" v-bind:style="getStyle(index, index2)" v-model = "el.content" :size = "el.content.length+1">
                                    <span v-if="showAns == 1" type = "text" v-bind:style="getStyle(index, index2)"> {{el.answer}}</span> 
                                    <span v-if="showAns == 2" type = "text" v-bind:style="getStyle(index, index2)">{{el.content}}</span>
                                </v-chip>
                                    <v-icon v-if="showAns == 2 && (myCompare(el.content,el.answer))"  v-bind:style="check_ok" >check_circle</v-icon>  
                                    <v-icon v-if="showAns == 2 && (!myCompare(el.content,el.answer))"  v-bind:style="check_error">error</v-icon>  
<!--                                 <v-chip v-if="showAns == 2 && (el.content != el.answer)" color="lime lighten-3">
                                    <span type = "text" v-bind:style="correct_answer">{{el.answer}}</span>
                                </v-chip> -->
                            </span>
                        </span>
                    </div>                
                </div>
            </div>

        </v-card>

    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
//import { closeSync } from 'fs';

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                fullContent: null,
                showAns: 0, // 0 - user content, 1 - correct content, 2 - check
                myList: [
                    {
                        type: 'p', // p, li
                        list: [
                            {
                                type: 'a', // a, c
                                content : '',
                                answer: '' // correct answer
                            }
                        ]

                    }
                ],
                ignoreSpaces : false,
                aqSome : false,
                check_ok : {
                    color: "green"                    
                },
                check_error : {
                    color: "red"
                },
                correct_answer : {
                    "text-align":"center"
                }

        }
    },
    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getTryAgainEvent'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
    //************************************************************************************ */        
    //  methods for content preparing
    //************************************************************************************ */        
        setBR(line) {
            var start = 0
            while (line.indexOf('\n') > -1) {
                start = line.indexOf('\n')
                if ((start > 0 ) && (start-1, start) != '§') {
                    line = line.substring(0,start) + '<br/>' + line.substring(start+1)
                }
            }
            return line
        },
        parseData(tag,endTag) {
            var mList = []
            // najdem poziciu kde zacina tag
            var start = this.fullContent.indexOf(tag);
            var start2 = 0
            // tili >
            // start2 je pozicia kde konci zobak daneho tagu
            if (tag == '<p>') {
                start2 = start + 2
            } else {
                start2 =  this.fullContent.indexOf('>',start);
            }

            // najdem poziciu kde konci tag </p, </pre>>
            var end = this.fullContent.indexOf(endTag)
            // ak bola pozicia uvodneho tagu nie na zaciatku napr. nejaky text este pred p alebo pre 
            // tak si ten obsah zapamatam ako content typ c
            if (start > 0) {
                // vlozim ju ako obsah - type je c
                mList.push( 
                    {
                      type: 'c',
                      content: this.fullContent.substring(0,start),
                      answer: ''
                    }
                )
            }
            // precitam obsah medzi tagmi
            var line = this.fullContent.substring(start2 + 1 , end)
            // change \n to br
            // ak robim s pre, potrebujem to dat do html takze musim nahradit dve medzery za sebou a entery 
            if (tag=='<pre') {
                // nahradza entery
                line = this.setBR(line)
                // toto vsetko dalsie nahradza medzery
                // spaces at the begin of line
                var spaces = '';
                while (line.indexOf(' ') == 0) {
                    spaces = spaces + '&nbsp;'
                    line = line.substring(1)
                }
                line = spaces + line
                // to last line
                while (line.indexOf('<br/> ') > -1) {
                    start = line.indexOf('<br/> ')
                    line = line.substring(0,start) + '<br/>&nbsp;' + line.substring(start+6)
                }
                while (line.indexOf('&nbsp; ') > -1) {
                    start = line.indexOf('&nbsp; ')
                    line = line.substring(0,start) + '&nbsp;&nbsp;' + line.substring(start+7)
                }
            }
            // nahradil som vsetko co bolo treba, zostrihnem zaciatok
            this.fullContent = this.fullContent.substring(end + endTag.length)

            // idem hladat ci v mojom medzitagovom texte ci tam nie su doplnovacky
            // kym su tak:
            while (line.indexOf('§§') > -1) {
                // najdem zaciatok
                start = line.indexOf('§§')
                // vsetko po zaciatocny paragraf je content
                if (start > 0) {
                    mList.push( 
                        {
                        type: 'c',
                        content: line.substring(0,start),
                        answer: ''
                        }
                    )
                }
                end = line.indexOf('§§',start+1)
                // vsetko po koncovy paragraf je na doplnenie
                // pamatam si aj spravnu odpoverd aby sa mi lahko porovnavalo
                // makeNice robi zobaciky a znaky, ktore su v html zakodovane na normalne znaky
                mList.push( 
                    {
                        type: 'a',
                        content: '',
                        answer: this.makeNice(line.substring(start+2, end))
                    }
                )                
                // ciara zo seba zostrihne pouzitu cast
                line = line.substring(end + 2)
                
            }

            // ak este po poslednom paragrafe mame nejaky obsah tak ho dopracujeme
            // if it is finished by </tag>
            if (line.indexOf(endTag) > 0) {
                line = line.substring(0,line.indexOf(endTag))                    
            }

            // to co ostalo je content
            if (line.length > 0) {                
                mList.push( 
                    {
                    type: 'c',
                    content: line,
                    answer: ''
                    }
                )
            } 

            // pre prislusny tag mam zoznam poloziek, 
            // ktore su kodovane ako c alebo a content alebo answer a podla toho potom vyrabam obsah v casti html
            // ktora je na zaciatku suboru
            this.myList.push( {
                type: tag,
                list: mList
            })

        },
        unSpan(txt) {
            var data = txt
            var start = 0
            var end = 0
            while (data.indexOf('<span') > -1) {
                start = data.indexOf('<span')
                end = data.indexOf('>',start)
                data = data.substring(0,start) + data.substring(end+1)
                start = data.indexOf('</span>')
                data = data.substring(0,start) + data.substring(start+7)
                
            }
            return data
        },
        //*********************************************************************************** */
        initData() {
            this.needInit = false         
            this.showAns = 0
            this.$store.commit('setFeedback', null)   
            this.myContent = (this.dcontent.data.content)            
            var globals = this.dcontent.data.globals
            if (globals.length > 0) {
               // globals = (globals)
                this.ignoreSpaces = globals.ignoreSpaces
                this.aqSome = globals.aqSome
            } else {
                this.ignoreSpaces = true
                this.aqSome = false
            }

            // typy prvkov su 3:
            // <p> pre obycajny text
            // <pre> pre kod
            // 
            
            // vo fullContent obsahujem cely obsah co prisiel co prisiel v podobe html
            this.myList = [] // zoznam do ktoreho budu nahodene postupne vsetky typy prvkov
            // unspan vyhodi vsetky spany bez ohladu na to co obsahuju - hladam zaciatocny tag, koncovy zobak a koncovy tag
            this.fullContent = this.unSpan(this.myContent.content)

            // tu sa rozhodujem ci este treba prehladava fullContent, v parseData sa z neho postupne od zaciatku zostrihuje
            // ak obsahuje <pre alebo <p (pozor mozu by za nimi parametre zato nie je zobak <pre uzavrety) tak ideme tahat obsah
            while (this.fullContent.indexOf('<p>') > -1 || this.fullContent.indexOf('<pre') > -1 ) { 
                // ak su tam obidva tagy vezmem ten, ktory je skor a idem vyextrahovat z fullContent prislusnu cast
                if ((this.fullContent.indexOf('<pre') > -1)  && (this.fullContent.indexOf('<p>') > -1)) {
                       if (this.fullContent.indexOf('<pre') > this.fullContent.indexOf('<p>')) {
                         this.parseData('<p>','</p>')       
                       } else {
                         this.parseData('<pre','</pre>')
                       }
                } else {
                    // ak je tam len jeden tak vezmem ten, ktory sa tam vyskytuje
                    if (this.fullContent.indexOf('<pre') > -1) {
                         this.parseData('<pre','</pre>')   
                    } else {
                        this.parseData('<p>','</p>')      
                    }    
                }
            }      
        },
        checkAnswer(owner) {
            this.$store.commit('setCheckAnswerEvent', false)
            
            var correct = 0
            var all = 0
            // correct and set answers
            var answList = []
            for(let i = 0; i < this.myList.length; i++) {
                for(let j = 0 ; j < this.myList[i].list.length; j++) {
                    if (this.myList[i].list[j].type == 'a') {                 // if there is answer
                        all++
                        if (this.myCompare(this.myList[i].list[j].answer, this.myList[i].list[j].content)) correct++
                        // add answers and correct
                        answList.push( {
                            correct: this.myList[i].list[j].answer, 
                            answer: this.myList[i].list[j].content
                            })
                    }
                }
            }

            let questionResult = Math.floor(correct/all*100 + 0.5)

            //if (questionResult < 100) 
            this.$store.commit('setTryAgainEvent',true)

            this.$store.commit('setAnswer',this.describeAnswer(owner,questionResult,answList))
            this.$store.commit('setCheckRatingEvent',true)

            this.showAns = 2
        },
        describeAnswer(user, score, lst) {
            return {
                solver: user,
                type: 5,
                answer: lst,
                answer_index: null, 
                rating: score
            }
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
            // set correct content
            for(let i = 0; i < this.myList.length; i++) {
                for(let j = 0 ; j < this.myList[i].list.length; j++) {
                    if (this.myList[i].list[j].type == 'a') {                 // if there is answer
                        this.myList[i].list[j].content = this.myList[i].list[j].answer
                    }
                }
            }

            this.checkAnswer('system')
            this.showAns = 2
        },
        getStyle(index, index2) {
            if (this.showAns == 0) return { "color":"black",
                                            "text-align":"center"}            
            if (this.showAns == 1) return { "background-color":"lime",
                                            "text-align":"center"}

            if (this.showAns == 2 && !(this.myCompare(this.myList[index].list[index2].content,this.myList[index].list[index2].answer))) 
                                            return { "color":"red",
                                                    "text-align":"center"}
            if (this.showAns == 2 && (this.myCompare(this.myList[index].list[index2].content,this.myList[index].list[index2].answer))) 
                                            return { "color":"green",
                                                    "text-align":"center"}
        },
        myCompare(a,b) {
            if (a == b) return true
            if (this.ignoreSpaces) {
                a = a.replace(/\s/g, '')
                b = b.replace(/\s/g, '')
                if (a == b) return true
            }                
            if (this.aqSome) {
                while (a.indexOf('"') > -1) a = a.replace('"','\'')
                while (b.indexOf('"') > -1) b = b.replace('"','\'')
            }
            if (a == b) return true
            return false
        },
        makeNice(a) {
            while (a.indexOf('&lt;')>-1) a = a.replace('&lt;','<')
            while (a.indexOf('&gt;')>-1) a = a.replace('&gt;','>')
            return a
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>
#mycode {
	width: 100%;
	padding: 5px;
	margin: 10px;
	overflow: auto;
	overflow-y: hidden;
	font-size: 14px;
	line-height: 18px;
    font-weight: bold;
	background: #998f8f77;
	border: 1px solid #777;
    font-family:'Courier New', Courier, monospace; 
}
.ql-snow .ql-editor pre.ql-syntax{background-color:#e0e0e0;color:#000;overflow:visible}
</style>